import { useForm } from "react-hook-form";
import { useCallback, useMemo } from "react";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import useRenderField from "../useRenderField";
import styles from "./style.module.scss";

const useSearchForm = (type, code) => {
    const initialFilter = useMemo(() => ({
        name: "",
        shortName: "",
        basicValue: "",
        amountIndicat: "",
        cipher: "",
        startedAt: null,
        endedAt: null,
        activity: null
    }), [code]);

    const {
        control,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        shouldFocusError: true,
        defaultValues: initialFilter,
    });

    const searchConfig = useMemo(() => [
        type === "billing" && code === "operation-types" && [
            {
                name: "name",
                placeholder: "Введите тип операции"
            },
            {
                name: "cipher",
                placeholder: "Введите шифр"
            }
        ],
        code !== "operation-types" && [
            {
                name: "name",
                placeholder: type === "monitoring" ? "Поиск по наименованию" : "Введите наименование"
            },
            type === "billing" && code !== "indicators" && {
                name: "shortName",
                placeholder: "Введите краткое обозначение"
            }
        ],
        type === "billing" && [
            code === "indicators" && {
                name: "shortName",
                placeholder: "Введите краткое обозначение"
            },
            code === "indicators" && {
                name: "basicValue",
                placeholder: "Выберите базовую величину",
                inputType: "dropdown",
                valueMode: "object",
                labelField: "sign",
                onOptionSelect: (option) => {
                    setValue("basicValue", option?.id || null);
                }
            },
            !(code === "basic-values" || code === "operation-types") && {
                name: "amountIndicat",
                placeholder: "Введите размер",
                inputType: "number"
            },
            (code === "taxes" || code === "operation-types") && {
                name: "activity",
                placeholder: "Выберите состояние активности",
                inputType: "dropdown"
            },
            code !== "basic-values" && {
                name: "startedAt",
                placeholder: "Введите дату начала действия",
                inputType: "date"
            },
            (code === "taxes" || code === "operation-types") && {
                name: "endedAt",
                placeholder: "Введите дату конца действия",
                inputType: "date"
            }
        ],
    ]
        .filter(row => row && typeof row === "object")
        .map(row => row.filter(elem => typeof elem === "object"))
        .filter(row => row.length),
        [type, code, setValue]
    );

    const renderField = useRenderField(control, errors);
    const searchForm = useCallback((actions) => (
        <div className={`p-d-flex ${styles.searchPanel}`}>
            {searchConfig.map((row, rowKey) => {
                const rowClassNames = [styles.searchFormRow];
                const fieldsContainerClassNames = [styles.fieldsContainer];

                switch (row.length) {
                    case 1:
                        if (searchConfig.length === 1) {
                            fieldsContainerClassNames.push(styles.longSearchField);
                        }
                        else if (searchConfig.length > 1) {
                            rowClassNames.push(styles.fullWidthInput);
                        }

                        break;
                    case 2:
                        fieldsContainerClassNames.push(styles.basicValueNamesContainer);
                        break;
                    case 3:
                        fieldsContainerClassNames.push(styles.tripleFieldsContainer);
                        break;
                    case 4:
                        fieldsContainerClassNames.push(styles.quadroFieldsContainer);
                        break;
                    default:
                        break;
                }

                return (
                    (
                        <div className={rowClassNames.join(" ")} key={rowKey}>
                            <div className={fieldsContainerClassNames.join(" ")}>
                                {row.map((field, itemKey) => (
                                    <IconField key={itemKey}
                                               className={styles.searchField}
                                               iconPosition="left"
                                    >
                                        <InputIcon className="pi pi-search"/>
                                        {renderField(
                                            code,
                                            {
                                                ...field, selectionMode: "range" },
                                            ""
                                        )}
                                    </IconField>
                                ))}
                            </div>

                            {rowKey === searchConfig.length - 1 && actions}
                        </div>
                    )
                )
            })}
        </div>
    ), [searchConfig, renderField, code]);

    return { searchForm, handleSubmit, reset, watch, isSubmitting };
}

export default useSearchForm;